import React, { FC } from 'react';
import { TDealerLocatorGeoLocationToastmessage } from '../../types/dealerLocatorLanding.types';
import Icon from '../../../@shared/icon';
import { iconSize } from '../../../../constants/icon.constants';
import DictionaryTerm from '../../../@shared/dictionaryTerm';
import './styles.scss';

const DealerLocatorGeoLocatorToastMessage: FC<TDealerLocatorGeoLocationToastmessage> = (props: TDealerLocatorGeoLocationToastmessage) => {
    const {showGeoLocationErrorMessage, updateShowGeoLocationErrorMessage, extraClassName=''} = props;
    return (
        < div className={`dealer-locator-landing-toast-msg ${showGeoLocationErrorMessage ? 'dealer-locator-landing-toast-msg--show' : 'dealer-locator-landing-toast-msg--hide'} ${extraClassName}`
        }>
            <Icon extraClassName='dealer-locator-landing-toast-msg__close' iconName="action-close" color="grey" size={iconSize['mbl']} onClick={() => { updateShowGeoLocationErrorMessage(false) }} />
            <p className='dealer-locator-landing-toast-msg__title'><DictionaryTerm keyword={'cnhi-geoLocationDisabledTitle'} /></p>
            <p><DictionaryTerm keyword={'cnhi-geoLocationDisabledErrorMessage'} /></p>
        </div >
    );

}

export default DealerLocatorGeoLocatorToastMessage;
